import { loadStripe } from '@stripe/stripe-js';

const stripePublishableKey = "pk_test_V8cgd71pGDAKe2q2BnHJZXsH00jdNxmY34";


export { loadStripe, stripePublishableKey };